/* eslint-disable no-useless-escape */
import {
    ButtonPrimary,
    Callout,
    IconInformationUserRegular,
    Text3,
    ButtonFixedFooterLayout,
    PhoneNumberField,
    EmailField,
    IconChevronLeftRegular,
    Text2,
    Text5,
    NavigationBar,
    skinVars,
} from '@telefonica/mistica';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { useTranslation } from 'react-i18next';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { updateCustomerData } from '../../../../services/CustomerService';
import { setInfoError } from '../../../../utils/dataTransformation/errorMesssages';
import FeedbackAddData from './feedbackAddData';
import { isBrowser } from 'react-device-detect';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import SnackbarMessage from '../../../../components/SnackbarMessage';
import useUserlight from '../../../../utils/hooks/useUserLight';
import { useQueryClient } from '@tanstack/react-query';
export interface AddPersonalDataInterface {
    fromDesktop?: boolean;
    setComponentSelected?: any;
    typeDesktop?: any;
}

export const AddPersonalData: React.FC<AddPersonalDataInterface> = ({
    fromDesktop,
    setComponentSelected,
    typeDesktop,
}: AddPersonalDataInterface) => {
    const { t } = useTranslation();
    const isLight = useUserlight();
    const navigate = useNavigate();
    const [valueMobile, setValueMobile] = useState<any>('');
    const [valueEmail, setValueEmail] = useState<any>('');
    const [checkButton, setCheckButton] = useState<boolean>(false);
    const { trackingScreenView } = new TrackingEvents();
    const queryClient = useQueryClient();
    const validateEmail = () => {
        let aux: boolean;
        const validRegex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (valueEmail.match(validRegex)) {
            aux = true;
        } else {
            aux = false;
        }
        return aux;
    };
    const storage = localStorage.getItem('storage');
    let storageJson: any;
    let type: any;
    if (storage) {
        storageJson = JSON.parse(storage);
        type = storageJson.typeSelected;
    }
    const typeOfChange = fromDesktop ? typeDesktop : type;
    const sendToNative = (param: any, description: any, type: any, title: any, err?: any) => {
        const url = param;
        const checkTitleFeedback = () => {
            let aux: any;
            if (typeOfChange === 'mobile' && description === 'SUCCESS') {
                aux = t('profileAddMobileFeedbackSuccessTitle');
            } else if (typeOfChange == 'email' && description === 'SUCCESS') {
                aux = t('profileAddEmailFeedbackSuccessTitle');
            } else if (description === 'ERROR') {
                aux = err.title;
            }
            return aux;
        };
        const checkSubtitleFeedback = () => {
            let aux: any;
            if (typeOfChange === 'mobile' && description === 'SUCCESS') {
                aux = t('profileAddMobileFeedbackSuccessSubtitle');
            } else if (typeOfChange == 'email' && description === 'SUCCESS') {
                aux = t('profileAddEmailFeedbackSuccessSubtitle');
            } else if (description === 'ERROR') {
                aux = err.localizedDescription;
            }
            return aux;
        };
        const titleFeedback = checkTitleFeedback();
        const subtitleFeedback = checkSubtitleFeedback();
        const state = description;
        const queryParams = {
            title: titleFeedback,
            subtitle: subtitleFeedback,
            state: state,
            errorCode: err ? err.id : '',
        };
        const storage = { type: typeOfChange, state: description, err: err ? err : '' };
        if (navigateParams(type, url, queryParams, storage)) {
            navigate(url);
        }
    };
    const personalData = () => {
        let aux: any;
        if (valueEmail === '') {
            aux = { contactNumber: valueMobile };
        } else if (valueMobile === '') {
            aux = { email: valueEmail };
        }
        return aux;
    };
    const getInfoCostumerDataUpdate = () => {
        updateCustomerData(personalData())
            .then(() => {
                queryClient.invalidateQueries(['customer-data']);
                if (fromDesktop) {
                    setComponentSelected(
                        <FeedbackAddData
                            fromDesktop={fromDesktop}
                            setComponentSelected={setComponentSelected}
                            typeVerificationDesktop={typeOfChange}
                            stateFeedbackDesktop={'SUCCESS'}
                        ></FeedbackAddData>,
                    );
                } else {
                    sendToNative('/profile/personal-data/add/feedback', 'SUCCESS', 'feedback-success', ' ');
                }
            })
            .catch((error: any) => {
                const { id, httpCode } = setInfoError(error);
                if (httpCode !== 401 && id !== 'X401502') {
                    if (fromDesktop) {
                        setComponentSelected(
                            <FeedbackAddData
                                fromDesktop={fromDesktop}
                                setComponentSelected={setComponentSelected}
                                typeVerificationDesktop={typeOfChange}
                                stateFeedbackDesktop={'ERROR'}
                                errDesktop={setInfoError(error)}
                            ></FeedbackAddData>,
                        );
                    } else {
                        sendToNative(
                            '/profile/personal-data/add/feedback',
                            'ERROR',
                            'feedback-error',
                            ' ',
                            setInfoError(error),
                        );
                    }
                }
            });
    };
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        if (typeOfChange === 'mobile') {
            setCheckButton(!valueMobile || (valueMobile && valueMobile.length !== 9));
        } else if (typeOfChange === 'email') {
            setCheckButton(!validateEmail());
        }
    }, [valueMobile, valueEmail]);

    if (isLight) {
        return <SnackbarMessage url='/profile' timeout={3000} />;
    }

    return (
        <div className='personal-data-add'>
            {isBrowser && (
                <>
                    <div className='personal-data-add__header-navigationBar'>
                        <NavigationBar
                            isInverse={true}
                            onBack={() => {
                                navigate(-1);
                            }}
                            title={
                                typeOfChange === 'mobile'
                                    ? t('personalDataAddMobileDesktop')
                                    : t('personalDataAddEmailDesktop')
                            }
                        />
                    </div>
                </>
            )}
            <ButtonFixedFooterLayout
                button={
                    <ButtonPrimary disabled={checkButton} onPress={() => getInfoCostumerDataUpdate()}>
                        {t('save')}
                    </ButtonPrimary>
                }
            >
                <div className='personal-data-add__wrapper'>
                    {fromDesktop && (
                        <>
                            <div className='personal-data-add__wrapper__header-return' onClick={() => {}}>
                                <div className='personal-data-add__wrapper__header-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.textLink} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.textLink}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                            <div className='personal-data-add__wrapper__titleDesktop'>
                                <Text5 color={skinVars.colors.textPrimary}>
                                    {typeOfChange === 'mobile'
                                        ? t('personalDataAddMobileDesktop')
                                        : t('personalDataAddEmailDesktop')}
                                </Text5>
                            </div>
                        </>
                    )}

                    <div className='personal-data-add__wrapper__text1'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {typeOfChange === 'mobile' ? t('personalDataAddMobileText') : t('personalDataAddEmailText')}
                        </Text3>
                    </div>
                    <div className='personal-data-add__wrapper__inputField'>
                        {typeOfChange === 'mobile' ? (
                            <PhoneNumberField
                                value={valueMobile}
                                name='phone'
                                label={t('personalDataMobile')}
                                helperText={t('personalDataHelperTextMobile')}
                                onChangeValue={setValueMobile}
                            />
                        ) : (
                            <EmailField
                                value={valueEmail}
                                name='email'
                                label={t('personalDataEmail')}
                                helperText={t('personalDataHelperTextEmail')}
                                onChangeValue={setValueEmail}
                            />
                        )}
                    </div>
                    <div className='personal-data-add__wrapper__callout'>
                        <Callout
                            icon={
                                <IconInformationUserRegular color={skinVars.colors.brand}></IconInformationUserRegular>
                            }
                            description={
                                typeOfChange === 'mobile'
                                    ? t('personalDataCalloutMobile')
                                    : t('personalDataCalloutEmail')
                            }
                        />
                    </div>
                </div>
            </ButtonFixedFooterLayout>
        </div>
    );
};

export default AddPersonalData;
